module.exports = __webpack_public_path__ + "img/icon_sports_trailrunning.1b9388e8.png";